module.exports = __webpack_public_path__ + "static/img/raspberry-m.eac3f5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/raspberry-m.jpg
// module id = CGCn
// module chunks = 0